export default __webpack_public_path__ + "4e26c63e9fc0d4299f38cdde1b367fa4.png";